import { type MouseEvent, type ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";
import MuiLink from "@mui/material/Link";
import type { LinkProps as MuiLinkProps } from "@mui/material/Link";
import { handleTitleLinkClick } from "./handleTitleLinkClick";

export interface ItemTitleLinkProps {
  /**
   * Путь раздела плюс query-параметры карточки, теми же именем и значением
   * `tab`, которыми раздел открывает карточку сейчас (см. образец
   * cabinet/src/partner/features/storage/ui/StorageList.tsx).
   */
  to: string;
  /** Программно открыть карточку элемента поверх списка. */
  onOpen: () => void;
  children: ReactNode;
  variant?: MuiLinkProps["variant"];
  color?: MuiLinkProps["color"];
  underline?: MuiLinkProps["underline"];
  noWrap?: boolean;
  className?: string;
  sx?: MuiLinkProps["sx"];
}

/**
 * Название элемента в списках партнёрского кабинета: настоящий `<a>` с
 * рабочим `href`, поэтому средняя кнопка мыши и cmd/ctrl-клик открывают
 * карточку в новой вкладке, а обычный левый клик, как и раньше, открывает
 * её диалогом поверх списка без перезагрузки страницы. Единый источник
 * правила перехвата клика для всех списков раздела: копировать его по
 * файлам запрещено спекой.
 */
export function ItemTitleLink({
  to,
  onOpen,
  children,
  ...linkProps
}: ItemTitleLinkProps) {
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    handleTitleLinkClick(event, onOpen);
  };

  return (
    <MuiLink
      component={RouterLink}
      to={to}
      onClick={handleClick}
      {...linkProps}
    >
      {children}
    </MuiLink>
  );
}
